import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Button from './components/Button';
import Container from './components/Container';
import Form from './components/Form';
import Input from './components/Input';
import { Caption, Description, Title } from './components/Typographies';
/**
 *
 * API:
 *
 * - [Newsletter API](https://components-extra.netlify.app/components/newsletter)
 */

var Newsletter = function Newsletter(_a) {
  var caption = _a.caption,
      children = _a.children,
      description = _a.description,
      forwardedRef = _a.forwardedRef,
      title = _a.title,
      rest = __rest(_a, ["caption", "children", "description", "forwardedRef", "title"]);

  return React.createElement(Container, Object.assign({
    ref: forwardedRef
  }, rest), title && React.createElement(Title, null, title), description && React.createElement(Description, null, description), children && React.createElement(Form, null, children), caption && React.createElement(Caption, null, caption));
};

var NewsletterExtra = styled(forwardRef(function (props, ref) {
  return React.createElement(Newsletter, Object.assign({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Exposed components
 */

NewsletterExtra.Button = Button;
NewsletterExtra.Input = Input;
export default NewsletterExtra;